<template>
  <div class="header">
    <div class="bg-top" />
    <b-navbar toggleable="lg">
      <b-navbar-brand href="/">
        <img src="../assets/img/logo.svg" alt="Biobá - Plataforma SocioBio" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="'/conteudo/quem-somos'">Quem somos</b-nav-item>
          <b-nav-item :to="'/conteudo/como-funciona'">Como funciona</b-nav-item>
          <b-nav-item :to="'/conteudo/o-que-move'">O que nos move</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="!currentUser">
            <router-link :to="'/entrar'" class="btn btn-secondary">ENTRE / FAÇA PARTE</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link :to="'/carrinho'" class="btn btn-primary btn-cart">
              <img src="../assets/img/icon-cart.svg" alt="Carrinho" /> &nbsp; {{ cart.length > 0 ? cart.length + " ITEMS" : "VAZIO" }}
            </router-link>
          </b-nav-item>
          <b-nav-item v-if="currentUser">
            <router-link :to="'/painel'" class="btn btn-default">Minha conta <img src="../assets/img/arrow-my-account.png" alt="Carrinho" /></router-link>
            <router-link :to="'/painel'"><UserPhoto :user="currentUser" /></router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import UserPhoto from '@/components/UserPhoto'
export default {
  components: {
    UserPhoto
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    currentUser () {
      return this.$store.state.currentUser
    }
  }
}
</script>
<style lang="sass" scoped>
  .bg-top
    background-image: url("../assets/img/bg-top.svg")
    background-position: center
    background-repeat: no-repeat
    height: 17px
  .navbar
    max-height: 70px
    margin-bottom: 75px
    background-color: #fff
    @media(max-width: 768px)
      margin-bottom: 120px
    @media(max-width: 992px)
      .navbar-collapse
        background-color: #fff
        padding: 20px
        border-radius: 30px
        z-index: 1000
        border-bottom: 1px solid
        text-align: center
    .navbar-brand
      background-image: url("../assets/img/logo-wrapper.png")
      width: 240px
      height: 145px
      margin-top: 89px
      background-size: 100%
      text-align: center
      @media (max-width: 992px)
        margin-top: -6px
      img
        max-width: 100%
        margin-top: 15px
    .navbar-nav
      .btn
        border-radius: 15px
        font-size: 12px
      .nav-item
        a:not(.btn)
          color: #215F60
          text-transform: uppercase
          font-size: 12px
      &.ml-auto
        .btn-cart
          &:hover
            background-color: #215F60
    .navbar-toggler
      margin-top: -97px
</style>
